import React from 'react';
import Label from './Label.jsx';

// placeholder function to derive props from metric and instanceId
export default function retrievePropsByMetricAndInstanceId(metric, instanceId, interval) {
    const title = _.get(metric, 'title', 'Profile Views');
    const description = _.get(metric, 'description', 'The number of times your profile was viewed during this time period.');
    const labelTitle = `${title} Per ${interval}`;
    const exportSubtitle = description;

    return {
        barProps: {
            label: <Label title={labelTitle} />,
            yAxisAllowDecimals: false
        },
        metricLoadingViewProps: {
            instanceId: instanceId
        },
        panelProps: {
            description: description,
            exportSubtitle: exportSubtitle,
            instanceId: instanceId,
            isExportable: true,
            showViewMore: false,
            title: title
        },
        summaryProps: {
            description: description,
            title: title
        }

    };
}
